import React from "react";
import ReactDOM from 'react-dom';
import NoticeDialog from "./NoticeDialog";
import NoticeListView from "./NoticeListView";
import { INoticeDelegate } from "./INoticeDelegate";
import { INotice } from "./INotice";
import NoticeItem from "./notice-item";


export default class NoticeManager implements INoticeDelegate {
	private static __singletonRef: NoticeManager;
	static getInstance(): NoticeManager {
		if (!NoticeManager.__singletonRef) {
			NoticeManager.__singletonRef = new NoticeManager();
		}
		return NoticeManager.__singletonRef;
	}
	private _noticeDelegate: INoticeDelegate;
	private _notices: Array<any> = [];
	private _show: boolean = true;
	private dialog: NoticeDialog;
	private listview: NoticeListView;
	private timerDic: any = {}; 
	constructor() {
		this.init();
	}
	init() {
		this._duration = 20; // 默认显示20秒
		this._maxCount = 10; // 显示10个
	}
	
	/**
	 * 显示时长n秒，通知在n秒后自动消失
	 */
	private _duration : number;
	public get duration() : number {
		return this._duration;
	}
	public set duration(v : number) {
		this._duration = v;
	}
	
	private _maxCount : number;
	public get maxCount() : number {
		return this._maxCount;
	}
	public set maxCount(v : number) {
		this._maxCount = v;
	}
	
	/**
	 * 设置通知是否可见
	 * @param visible 是否可见
	 */
	setIsVisible(visible:boolean) {
		this._show = visible;
		if(this.dialog) {
			this.dialog.setIsVisible(visible);
			this.dialog.forceUpdate();
		}
	}
	
	/**
	 * 显示传入的所有通知
	 * @param notices 通知数据数组
	 */
	show(notices: Array<any>) {
		this._notices = notices;

		this.handleData();

		// 刷新UI
		this.updateUI();
	}
	/**
	 * 将传入的通知显示出来
	 * @param notices 通知数据数组
	 */
	append(notices: Array<any>) {
		this._notices = this.distinct(this._notices, notices);
		this.handleData();
		// 刷新UI
		this.updateUI();
	}
	/**通过url去重 */
	distinct(a: Array<any>, b: Array<any>) {
		let arr = a ? a.concat(b) : b || [];
		let result:Array<any> = []
		let obj: any = {}

		for (let i of arr) {
			if (i.url && !obj[i.url]) {
				result.push(i)
				obj[i.url] = 1
			}
		}

		return result
	}
	handleData(): Array<any>{
		this._notices = this._notices.sort((a, b) => {
			return b.startTimeValue - a.startTimeValue;
		})
		if (this._notices.length > this.maxCount) {
			this._notices = this._notices.slice(0, this.maxCount);
		}
		return this._notices
	}

	updateUI() { 
		if (this.dialog && this.listview) {
			this.listview.forceUpdate();
		} else {
			this.initDialog();
		}
		
	}
	onClose() {
		this._show = false;
		this.updateUI();
	}
	initDialog() {
		const id = 'notice-wrapper-board';
		let board = document.getElementById(id);
		if (!board) {
			board = document.createElement('div');
			board.id = id;
			document.body.appendChild(board);
		}
		ReactDOM.render(
			<NoticeDialog ref={ref => (this.dialog = ref!)}
				onClose={this.onClose.bind(this)}
				show={this._show}
			>
				<NoticeListView
					ref={ref => (this.listview = ref!)}
					delegate={this.getNoticeDelegate()}
				></NoticeListView>
			</NoticeDialog>, board)
	}
	getNoice(index: number) {
		if (this._notices && this._notices.length > index) {
			let notice = this._notices[index];
			return notice;
		}
		return null;
	}
	onCloseNotice(notice: any) {
		if (!notice || !notice.url) { return; }
		this.clearTimer(notice.url);
		let newNotice : Array<any> = [];
		for (let i = 0; i < this._notices.length; i++){
			let n = this._notices[i];
			if (n.url !== notice.url) {
				newNotice.push(n);
			}
		}
		this.show(newNotice);
	}
	clearTimer(url: string) {
		let oldTimer = this.timerDic[url];
		if (oldTimer) {
			clearTimeout(oldTimer);
			delete this.timerDic[url];
		}
	}

	setNoticeDelegate(obj: INoticeDelegate) {
		this._noticeDelegate = obj;
	}
	getNoticeDelegate(): INoticeDelegate {
		return this._noticeDelegate || this;
	}

	numberOfRows(): number{
		return this._notices.length > this.maxCount ? this.maxCount : this._notices.length;
	}
	heightForRowAtIndex(view:any, index: number): number{
		return 89+16;
	}
	cellForRowAtIndexPath(view: any, index: number): any{
		let notice = this.getNoice(index);
		if (notice) {
			let notice = this._notices[index];
			let name = notice.name;
			let time = notice.startTime;
			let url = notice.url;
			let onClose = () => {
				this.onCloseNotice(notice);
			}

			if(!this.timerDic[url]){
				let timer = setTimeout(() => {
					// 30分钟自动关闭
					this.onCloseNotice(notice);
				}, this.duration * 1000);
				this.timerDic[url] = timer;
			}



			return <NoticeItem data={notice}
				onClose={onClose.bind(this)}
			></NoticeItem>;
		}
	}
	reactKeyRowAtIndexPath(view: any, index: number): string{
		let notice = this.getNoice(index);
		if (notice) { 
			return notice.url;
		}
		return 'null';
	}
}